import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models';

import { UitkSelect } from 'uitk-react-input';

import { FormFieldBinding } from 'components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

interface FlightCabinClassProps extends LocalizedComponentProps, SearchFormFieldProps {
  model: SearchCriteriaModel;
}

const TrackedSelect = ClickTracker(UitkSelect);

@withLocalization
@FormFieldBinding
export class FlightCabinClass extends React.Component<FlightCabinClassProps> {
  private name: string;
  private label: string;
  private preferredClassOptions;
  private icon = 'airline_seat_recline_extra';

  constructor(props: FlightCabinClassProps) {
    super(props);

    this.name = props.modelKey;
    this.label = props.l10n.formatText('hotels.preferredClass.multiitem.label');
    this.preferredClassOptions = [
      { label: this.props.l10n.formatText('hotels.preferredClass.multiitem.dialog.economy.label'), value: 'COACH' },
      { label: this.props.l10n.formatText('hotels.preferredClass.multiitem.dialog.premiumEconomy.label'), value: 'PREMIUM_ECONOMY' },
      { label: this.props.l10n.formatText('hotels.preferredClass.multiitem.dialog.business.label'), value: 'BUSINESS' },
      { label: this.props.l10n.formatText('hotels.preferredClass.multiitem.dialog.firstClass.label'), value: 'FIRST' },
    ];
  }

  public render() {
    const { model, updateModel: onChange } = this.props;

    return (
      <div className="uitk-cell s-cell-1-1 m-cell-1-2 l-cell-1-3 xl-cell-1-3">
        <TrackedSelect
          id={this.name}
          name={this.name}
          label={this.label}
          icon={this.icon}
          onChange={onChange}
          value={model.cabinClass}
          rfrr="CabinClass"
          linkName="Select flight cabin class"
        >
          {this.preferredClassOptions.map(option => (
            <option value={option.value} key={option.label}>
              {option.label}
            </option>
          ))}
        </TrackedSelect>
      </div>
    );
  }
}
